// extracted by mini-css-extract-plugin
export var container = "_4r-0";
export var icon = "_4r-1";
export var text = "_4r-2";